import script from "./transaction-page.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-page.vue?vue&type=script&setup=true&lang=js"

import "./transaction-page.vue?vue&type=style&index=0&id=7956d05e&lang=css"

const __exports__ = script;

export default __exports__